<div class="row">
  <div class="col-md-12 -px-0 py-3">
    <form>
      <!-- Acc Info -->
      <div class="row">
        <div class="col-12 form-group mb-0">
        <h3
          style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
            Account Information
          </h3>
        </div>
      </div>

      <!-- Filed Starts -->
      <div class="row">
          <div class="col-md-4 form-group formInp">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" disabled
              [value]="'XXXXXXXX'+ getProfileData?.bank_details?.account_number"
              *ngIf="getProfileData?.bank_details?.account_number" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3 dis-font">
                  Account Number
                </span>
            </label>
          </div>
        </div>
          <div class="col-md-4 form-group formInp">
          <div class="custom-form flex-grow-1 me-md-3">
              <input class="input_field px-3 pt-3" disabled [value]="'XXXXX'+ sliceRouting" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3 dis-font">
                  Routing Number
                </span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
          <div class="col-md-4 form-group" *ngIf="getProfileData?.stripe_data?.account_type == 'individual'">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" disabled
            [value]="getProfileData?.bank_details?.account_holder_name || getProfileData?.stripe_data?.company_name" />
            <label class="label-name">
              <span class="content-name f-c-p-3 dis-font">Account holder name</span>
              </label>
          </div>
        </div>
        <div class="col-md-4 form-group">
          <div class="custom-form flex-grow-1 me-md-3">
            <input class="input_field px-3 pt-3" disabled [value]="modalDetails.ssn" />
              <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                  {{getProfileData?.stripe_data?.account_type == 'individual' ? 'Social Security Number' : 'Company Tax
                  ID'}}
              </span>
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="col-12" *ngIf="getProfileData.display_message || getProfileData.display_message_address || getProfileData.display_message_mobile ||
        getProfileData.display_message_photo || getProfileData.display_message_ssn">
        <hr />
        <small class="color_animation">
          {{getProfileData.display_message || getProfileData.display_message_address || getProfileData.display_message_mobile ||
          getProfileData.display_message_photo || getProfileData.display_message_ssn}}
        </small>
      </div> -->

    </form>
    <!-- <p style="color:#1C76BA; text-decoration: none;cursor: pointer;" (click)="OtherAccountInformation()">
      <u>View Account Information</u>
    </p> -->
    <div class="row mt-2">
      <div class="col-12" *ngIf="getProfileData?.stripe_data?.account_type == 'individual'">
        <h3
          style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
          Identity Document</h3>

        <div class="col-xl-8 d-flex align-item-center py-4 px-3"
          style="background: #FFFFFF ; max-width: 700px; border: 1px solid #dee2e6 !important; border-radius: 10px;">
          <div class="row justify-content-between w-100">
            <div class="col-md-6">
              <img style="margin-bottom: -31px;margin-left: -5px;" src="assets/img/png/left.png">
              <div class="card-photo">Photo ID - Front</div>
              <label for="my-file_1" class="input-file-trigger input_lable"
                *ngIf="getProfileData?.stripe_data?.individual_document_verified == 0">
                <div class="d-flex input-file-container ms-4 mt-2 align-items-center">
                  <input accept="image/*" class="input-file d-none" (change)="uploadPhotoId($event, 'F')" id="my-file_1"
                    type="file" />
                  <label tabindex="0" for="my-file_1" class="ms-2 btn input-file-trigger input_lable"
                    style="border: 2px solid; margin-bottom: 0;"> Upload</label>
                  <p class="file-return" *ngIf="photoIdEvidenceFront ">
                    {{ photoIdEvidenceFront?.name || "" }}
                  </p>
                </div>

              </label>

              <strong *ngIf="getProfileData?.stripe_data?.individual_document_verified == 1"
                style="color: #00BC8B; margin-left: 2rem;">Provided</strong>
            </div>

            <div class="col-md-6 mt-md-0 mt-3"
              *ngIf="photoIdEvidenceFront || getProfileData?.stripe_data?.individual_document_verified == 1">
              <img style="margin-bottom: -31px;margin-left: -5px;" src="assets/img/png/right.png">
              <div class="card-photo">Photo ID - Back</div>
              <label for="my-file1" *ngIf="getProfileData.stripe_data.individual_document_verified == 0">
                <div class="d-flex input-file-container ms-4 mt-2 align-items-center">
                  <input class="input-file d-none" accept="image/*" (change)="uploadPhotoId($event, 'B')" id="my-file1"
                    type="file" />
                  <label tabindex="0" for="my-file1" class="ms-2 btn input-file-trigger input_lable"
                    style="border: 2px solid; margin-bottom: 0;">Upload</label>
                  <p class="file-return" *ngIf="photoIdEvidenceBack">
                    {{ photoIdEvidenceBack?.name || "" }}
                  </p>
                </div>
              </label>

              <strong *ngIf="getProfileData?.stripe_data?.individual_document_verified == 1"
                style="color: #00BC8B; margin-left: 2rem;">Provided</strong>
            </div>
          </div>
        </div>

        <div class="col-12 py-3" *ngIf="getProfileData?.stripe_data?.individual_document_verified == 0">
          <button class="large-btn px-4 btn-lg" style="height: 42px; width: 110px;" mat-raised-button
            (click)="uploadImages()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>